/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Created by sprout on 2018-03-05.
 */
// import * as util from '../utils/util';
(function ($) {
    "use strict";

    nc.lineage.mainNshop = function (options) {
        if (!options) return;
        var option = $.extend({
            wrap: null,
            sendData: null,
            device: null,
            global: global || window
        }, options);

        //console.log(  global.isTestServer() , option.device == 'ingame' );
        if (global.isTestServer() && option.device == 'ingame') {
            $('.wrap-section-nshop').css('display', 'none');
            return;
        } else {
            init();
        }

        function init() {
            // render by data, condition
            setInstance(option.data);
        }

        function setInstance(data) {
            var _data = data;
            var tpl = '';

            tpl += '<header><h2>' + data.header + '</h2></header>\n                <article id="nshopRoll">\n                    <div class="slick-item">\n                ';

            $.each(data.items, function (idx, val) {

                if (idx == 4 || idx == 8) {
                    tpl += ' </div><div class="slick-item"> ';
                }

                var isGrade = val.grade ? '<i class="grade_vip">' + __webpack_require__(3) + '</i>' : '';
                var isPoint = val.point ? '<i class="price_point">' + __webpack_require__(4) + '</i>' : '';
                var nshopUrl = option.device == 'launcher' ? val.url.replace(/lineagenshop.plaync.com/i, 'launcher-lineagenshop.plaync.com').replace(/rc./i, 'rc-') : val.url;

                tpl += '\n                    <section class="nshop__item">\n                        <a href="' + nshopUrl + '" data-index=' + idx + ' onmousedown="eval(\'try{ _trk_clickTrace( \'EVT\', \'/\uB9AC\uB2C8\uC9C0/\uBA54\uC778N\uC0F5\' );}catch(_e){}\');"><span class="flag flag-' + val.flag + '"></span><dl><dd class="thumb"><img src="' + val.thumbnail + '" alert="' + val.title + '"></dd><dt>' + val.title + '</dt><dd class="price">' + isGrade + isPoint + '<i class="price_ncoin">' + __webpack_require__(5) + '</i><strong>' + val.ncoin + '</strong></dd></dl></a>\n                        </section>\n                        ';
            });

            tpl += '</article>\n                </div>\n                ';

            var articleWrap = option.wrap;

            articleWrap.append(tpl);
            setSlick();
        }
        function setSlick() {

            $('#nshopRoll').slick({
                dots: true,
                infinite: false,
                arrows: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 640,
                    slidesToShow: 2
                }]
            });
        }

        function showLoadingBar(flag) {
            if (flag) {
                $('.loading-bar').show();
            } else {
                $('.loading-bar').hide();
            }
        }
    };
})(jQuery);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><circle cx=\"9\" cy=\"9\" r=\"9\" fill=\"#836AB5\"></circle><path fill=\"#FFF\" d=\"M9.564 8.86H8.298c-.046 0-.064-.024-.056-.072l.34-2.075c.008-.048.034-.073.08-.073h1.266c.7 0 1.045.45.936 1.116-.11.668-.6 1.105-1.3 1.105zM7.38 13.35c.067 0 .12-.048.133-.121l.451-2.754c.008-.05.035-.073.08-.073h1.368c1.662 0 2.858-1.093 3.112-2.646.259-1.576-.57-2.656-2.243-2.656H7.298c-.067 0-.12.048-.133.121L5.852 13.23c-.012.073.025.121.093.121h1.436z\"></path></svg>"

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill=\"#F7A800\" d=\"M18.965 12.51l-6.455 6.455a3.56 3.56 0 0 1-5.02 0L1.035 12.51a3.56 3.56 0 0 1 0-5.02L7.49 1.035a3.56 3.56 0 0 1 5.02 0l6.455 6.455a3.56 3.56 0 0 1 0 5.02\"></path><path fill=\"#FFF\" d=\"M11.578 9.723s-.013.963-.375 1.124c0 0-.288.222-.5.25h-.875s-.506.012-.499-.25c.023-.856 0-3.748 0-3.748s.329-.087.5-.125c.25-.055.624 0 .624 0s.572.02.875.5c0 0 .269.205.25 1.5-.02 1.293 0 .749 0 .749M10.953 5.1H9.58c-1.993.067-2.374.624-2.374.624s-.011 8.804 0 9.12c.012.315.25.25.25.25h1.749c.193.001.125-.25.125-.25v-2.249c.18.14 1.749.125 1.749.125 2.526-.288 2.498-2.873 2.498-2.873V7.849c-.169-2.858-2.623-2.748-2.623-2.748\"></path></svg>"

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path fill=\"#F16126\" d=\"M18.965 12.51l-6.455 6.455a3.56 3.56 0 0 1-5.02 0L1.035 12.51a3.56 3.56 0 0 1 0-5.02L7.49 1.035a3.56 3.56 0 0 1 5.02 0l6.455 6.455a3.56 3.56 0 0 1 0 5.02\"></path><path fill=\"#FFF\" d=\"M12.5 6.989s-2.374-.279-2.809 0c0 0-1.02.471-1.02 1.957v2.108c-.018 1.486 1.02 1.957 1.02 1.957.435.279 2.809 0 2.809 0v1.829c-.877.277-2.68.26-2.68.26-3.038-.002-3.32-3.394-3.32-3.394V8.294S6.782 4.902 9.82 4.9c0 0 1.803-.017 2.68.261V6.99z\"></path></svg>"

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main/main-nshop.js